var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":"primary","open-delay":"100"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"back-button-container pt-3",on:{"click":function($event){return _vm.backToWorkspace()}}},on),[_c('BackToWorkspaceIcon',{staticClass:"back-button"})],1)]}}])},[_vm._v(" "),_c('span',{staticStyle:{"font-size":"9px"}},[_vm._v(_vm._s(_vm.$t("BackToWorkspaceSelection")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623f9c76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavBar/BackToWorkspaceSelection.vue
// module id = null
// module chunks = 